import { SmartLink } from './SmartLink'
import { useLanguage } from '../i18n'

export function Footer() {
  const { copy } = useLanguage()

  return (
    <footer className="site-footer">
      <div className="container footer-grid">
        <div className="footer-brand">
          <a href="#top" aria-label="GeniusLEAD — voltar ao topo">
            <img className="footer-logo" src="/assets/logos/geniuslead-footer.svg" alt="" aria-hidden="true" />
          </a>
          <p>{copy.footer.signature}</p>
        </div>

        <nav className="footer-links" aria-label="Navegação do rodapé">
          {copy.navigation.links.map(([label, href]) => (
            <SmartLink key={label} href={href}>{label}</SmartLink>
          ))}
        </nav>

        <div className="footer-contact">
          <a href="mailto:comercial@geniuslead.com.br">comercial@geniuslead.com.br</a>
          <a href="https://wa.me/5515981151208" target="_blank" rel="noopener noreferrer">+55 15 98115-1208</a>
        </div>
      </div>

      <div className="container footer-bottom">
        <span>{copy.footer.copyright}</span>
      </div>
    </footer>
  )
}
